<p>
  <button app-add-button [label]="'events.settings.registration-fields.ceu-edit.add-ceu-label' | translate" (onClick)="handleAddClick()">
  </button>
</p>

<table class="wl-credit-types-grid" [hidden]="!availValueCreditTypes?.length">
  <thead>
    <tr>
      <th></th>
      <th>
        {{ 'events.settings.registration-fields.ceu-edit.credit-type-column-header' | translate | titlecase }}
      </th>
      <th>
        {{ 'events.settings.registration-fields.ceu-edit.ceu-credits-column-header' | translate | titlecase }}
      </th>
    </tr>
  </thead>
  <tbody>
    <tr
      *ngFor="let availValueCreditType of availValueCreditTypes"
      [ngClass]="{ 'wl-pending-delete': availValueCreditType.ObjectState == _objectStateEnum.Deleted }"
    >
      <td>
        <button
          pButton
          class="btn btn-danger btn-xs"
          type="button"
          (click)="handleRemoveClick(availValueCreditType)"
          [hidden]="availValueCreditType.ObjectState == _objectStateEnum.Deleted"
          icon="pi pi-trash"
        ></button>
        <button
          pButton
          class="btn btn-default btn-xs"
          type="button"
          (click)="handleUnRemoveClick(availValueCreditType)"
          [hidden]="availValueCreditType.ObjectState != _objectStateEnum.Deleted"
          [title]="'common.undelete' | translate | titlecase"
          icon="pi pi-refresh"
        ></button>
      </td>
      <td>
        <wl-events-ceu-type-dropdown
          [(ngModel)]="availValueCreditType.CeCreditTypeId"
          inputCssClass="form-control wl-credit-type-input"
          [required]="true"
          [disabled]="availValueCreditType.ObjectState == _objectStateEnum.Deleted"
        ></wl-events-ceu-type-dropdown>
      </td>
      <td>
        <input
          [(ngModel)]="availValueCreditType.Credits"
          class="form-control wl-credits-input"
          type="number"
          min="0"
          [disabled]="availValueCreditType.ObjectState == _objectStateEnum.Deleted"
        />
      </td>
    </tr>
  </tbody>
</table>
